import "regenerator-runtime/runtime"
import Amplify from "aws-amplify"
import storage from "./storage"
import acceptShareAuth from "./share-auth"

Amplify.configure({
  Auth: {
    region: "ap-northeast-1",
    userPoolId: process.env.COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.COGNITO_WEB_CLIENT_ID,
    storage: storage,
  }
});

acceptShareAuth()
